/**Dependencies */
import React, { useState, useEffect, useRef } from "react";
import lightbox from "lightbox2"; // Importamos la librería lightbox2
import Slider from "react-slick";
import { settingsInfoHotel } from "../utils";

/**components */
import {
  Row,
  Col,
  Image,
  Tab,
  Nav,
  Container,
  Button,
  Form,
  Modal,
} from "react-bootstrap";
import { InteractiveSelector } from "../components/InteractiveSelector";
import { CarouselCards } from "../components/CarouselCards";
import { CheckOutCart } from "../components/CheckOutCart";

/**Styles */
import "../styles/experiencias.scss";
/**Images */
import imgStar from "../images/icons/star-purple.png";
import rivieraMaya from "../images2/Adentrate en la Riviera Maya.png";
import aventurasVallarta from "../images2/Aventuras en Vallarta.png";
import acapulco from "../images2/Emociones intensas en Acapulco.png";
import xenses from "../images2/hotels/Parque Xenses.png";
import fiestaAmericana from "../images2/hotels/Grand Fiesta Americana.png";
import moonPalace from "../images2/hotels/Moon Palace.png";
import cancun from "../images2/Enamorate de Cancun.png";
import recuerdosInolvidables from "../images2/Recuerdos inolvidables en los Cabos.png";
import hiltonCancun from "../images2/Hilton Cancun Mar Caribe.png";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import xcaret from "../images2/hotels/Parque Xcaret.png";
import xcaret2 from "../images2/hotels/xcaret2.png";
import xcaret3 from "../images2/hotels/xcaret3.png";
import xcaret4 from "../images2/hotels/xcaret4.png";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FaLocationDot, FaPhoneVolume } from "react-icons/fa6";
import bannerAyuda from "../images2/banner-ayuda-men.png";
import Swal from "sweetalert2";
import {
  Currency,
  fetchMarkup,
  FormatCancellationPoliciesAct,
  FormatDate,
  totalPrices,
} from "../helpers";
import { getActividades, getActvidadDetalle } from "../services/searchService";
import { getActivePDP } from "../services/checkoutService";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GalleryInfo } from "../components/GalleryInfo";
import { SearchEngine } from "../components/SearchEngine";
import { Loader } from "../components/Loader";
import { CardCarrousel } from "../components/CardCarrousel";
import { GeneralForm } from "../components/GeneralForm";
import { comisionUser } from "../services/LoginService";

/**
 * Muestra la información de la experiencia, incluyendo una imagen principal, thumbnails,
 * una descripción, un itinerario, lo que incluye y no incluye, y una selección interactiva
 * de destinos similares.
 *
 * @returns {React.ReactElement} Un JSX con la información de la experiencia.
 */
export const InfoExperiencia = () => {
  const [comisionUsuario, setComisionUsuario] = useState(0);
  const [userData] = useState(
    JSON.parse(localStorage.getItem("dataUser") || 0)
  );
  const images = [
    { img: xcaret, alt: "Imagen de la experiencia" },
    { img: xcaret2, alt: "Imagen de la experiencia" },
    { img: xcaret3, alt: "Imagen de la experiencia" },
    { img: xcaret4, alt: "Imagen de la experiencia" },
    { img: xcaret2, alt: "Imagen de la experiencia" },
  ];
  const [activeKey, setActiveKey] = useState("description");

  const cardsDestinos = [
    {
      title: "Adéntrate en la Riviera Maya",
      img: rivieraMaya,
      btnText: "Descubre más",
    },
    {
      title: "Recuerdos inolvidables en Los Cabos",
      img: recuerdosInolvidables,
      btnText: "Descubre más",
    },
    { title: "Enamórate de Cancún", img: cancun, btnText: "Descubre más" },
    {
      title: "Adéntrate en la aventura de Vallarta",
      img: aventurasVallarta,
      btnText: "Descubre más",
    },
    {
      title: "Disfruta de las maravillas de Acapulco",
      img: acapulco,
      btnText: "Descubre más",
    },
  ];
  const [show, setShow] = useState(false);
  const [hideSearchDestination, setHideSearchDestination] = useState("none");
  const [selectedDates, setSelectedDates] = useState([]);
  const [totalPersons, setTotalPersons] = useState([]);
  const [persons, setPersons] = useState([]);
  const [nameDestination, setNameDestination] = useState("");
  const [acts, setActs] = useState([]); // Estado para los hoteles
  const [nights, setNights] = useState(0);
  const [markup, setMarkup] = useState("");
  const [modality, setModality] = useState(null);
  const [totalEdades, setTotalEdades] = useState([]);
  const [dateSelected, setDateSelected] = useState("");
  const [cancellationPolicies, setCancellationPolicies] = useState(null);
  const [lang, setLang] = useState([]);
  const [selectedLang, setSelectedLang] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showSearchEngine, setShowSearchEngine] = useState(false);
  const [pdp, setPdp] = useState();
  const [randomActivities, setRandomActivities] = useState([]);
  const [arrSession, setArrSession] = useState(
    JSON.parse(sessionStorage.getItem("datosReserva")) || []
  );
  const [loading, setLoading] = useState(true); // Indicador de carga
  const [timeNights, setTimeNights] = useState();

  const location = useLocation();
  const navigate = useNavigate();
  let rateKey;
  let politicasText = "";
  // Función para parsear los parámetros de la URL
  const parseQueryParams = (query) => {
    return Object.fromEntries(new URLSearchParams(query));
  };
  const queryParams = parseQueryParams(location?.search);
  let requestData = [];

  useEffect(() => {
    const comision = async () => {
      try {
        if (userData?.usuario?.id) {
          const response = await comisionUser(userData?.usuario?.id);
          setComisionUsuario(response);
        } else {
          setComisionUsuario(0);
        }
      } catch (error) {
        throw new Error("error connection: " + error);
      }
    };

    comision();
  }, []);

  // Usamos useEffect para inicializar lightbox.js cuando el componente se monta
  useEffect(() => {
    lightbox.option({
      resizeDuration: 200,
      wrapAround: true,
      fadeDuration: 300,
    });
  }, []);

  const cardRef = useRef(null);

  useEffect(() => {
    const fetchMarkupPanel = async () => {
      try {
        const markupData = await fetchMarkup("experiencias");
        setMarkup(markupData?.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanel();
  }, []);

  useEffect(() => {
    const pasarelaActiva = async () => {
      try {
        const pasarela = await getPdp();
        setPdp(pasarela);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    pasarelaActiva();
  }, []);
  const getPdp = async () => {
    try {
      const response = await getActivePDP();
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  const handleScrollToCard = () => {
    cardRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  /**
   * Función para manejar el envío del formulario de contacto,
   * esta función se encarga de tomar los datos del formulario,
   * llamar al servicio para enviar el correo y mostrar un mensaje
   * de success o error dependiendo del resultado.
   *
   * @returns {Promise<void>}
   */
  const construirRequest = () => {
    // Extraemos los parámetros de la URL
    const code = queryParams?.idActividad; // ID del destino
    const checkInDate = queryParams?.in;
    const checkOutDate = queryParams?.out;
    const idDestino = queryParams?.idDestino;
    setSelectedDates([checkInDate, checkOutDate]);
    // Crear habitaciones a partir de los parámetros pax
    const personas = Object.keys(queryParams)
      ?.filter((key) => key?.startsWith("pax")) // Filtramos las claves que empiezan con 'pax'
      ?.map((key) => {
        const [adultos, edadesAdults, menores, edades] =
          queryParams[key].split("|");
        return {
          num_adultos: parseInt(adultos, 10),
          num_menores: parseInt(menores, 10),
          edad_adultos: edadesAdults ? edadesAdults?.replace(/,/g, "|") : "", // Convertimos comas en pipes
          edad_menores: edades ? edades?.replace(/,/g, "|") : "", // Convertimos comas en pipes
        };
      });

    const personasFormatted = Object.keys(queryParams)
      ?.filter((key) => key?.startsWith("pax")) // Filtramos las claves que empiezan con 'pax'
      ?.map((key) => {
        const [adultos, edadesAdults, menores, edades] =
          queryParams[key].split("|");

        // Convertir edades (si las hay) en un array
        const edadesArray =
          edades === "0" || !edades ? [] : edades?.split(",")?.map(Number);
        const edadesAdultsArray =
          edadesAdults === "0" || !edadesAdults
            ? []
            : edadesAdults?.split(",")?.map(Number);

        // Devolver el objeto con la estructura requerida
        return {
          adults: parseInt(adultos, 10),
          minors: parseInt(menores, 10),
          agesAdults: edadesAdultsArray,
          ages: edadesArray,
        };
      });
    setPersons(personasFormatted);
    setTotalPersons(personas);
    // Construir el objeto final
    const request = {
      codigo: code,
      fechas: {
        checkin: checkInDate,
        checkout: checkOutDate,
      },
      personas,
    };
    const requestActivities = {
      destino: {
        tipo: "destination",
        id: idDestino,
      },
      fechas: {
        checkin: checkInDate,
        checkout: checkOutDate,
      },
      personas,
    };

    return [request, requestActivities];
  };

  useEffect(() => {
    requestData = construirRequest(); // Esto solo se ejecuta cuando `location.search` cambia
  }, [location?.search]);

  useEffect(() => {
    // Obtener la URL actual
    const queryParams = parseQueryParams(location?.search);

    // Obtener las fechas de entrada y salida de la URL
    const checkInDate = queryParams?.in;
    const checkOutDate = queryParams?.out;

    if (checkInDate && checkOutDate) {
      const checkIn = new Date(checkInDate);
      const checkOut = new Date(checkOutDate);
      const timeDifference = checkOut - checkIn;
      const totalNights = timeDifference / (1000 * 3600 * 24);

      setNights(totalNights);
    }

    const dataNight = [checkInDate, checkOutDate];

    setTimeNights(dataNight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchActividades = async () => {
    try {
      const response = await getActvidadDetalle(requestData[0]);
      return response;
    } catch (error) {
      console.error("Error fetching activity:", error);
      return [];
    }
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const activityData = await fetchActividades();

        setNameDestination(
          activityData?.activity?.country?.destinations?.[0]?.name
        );
        setActs(activityData);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.search]);

  function langs() {
    const language = modality?.rates?.[0]?.rateDetails?.map(
      (rateDetail) => rateDetail
    );
    setLang(language);
  }

  useEffect(() => {
    langs();
  }, [modality?.rates?.[0]?.rateDetails]);
  useEffect(() => {
    if (acts?.activity?.modalities?.length > 0) {
      setModality(acts?.activity?.modalities?.[0]);
    }
  }, [acts?.activity?.modalities]);

  useEffect(() => {
    if (modality?.rates?.[0]?.rateDetails?.length > 0) {
      setCancellationPolicies(
        modality?.rates?.[0]?.rateDetails[0]?.operationDates?.[0]
      );
    }
  }, [modality?.rates?.[0]?.rateDetails]);
  function changeModality(modality) {
    setModality(modality);
  }

  useEffect(() => {
    if (modality?.rates?.[0]?.rateDetails?.length > 0) {
      const firstDate =
        modality?.rates?.[0]?.rateDetails?.[0]?.operationDates?.[0]?.from;
      if (firstDate) {
        //setDateSelected(firstDate);
        updateCancellationPolicy(firstDate);
      }
    }
  }, [modality]);

  useEffect(() => {
    let isMounted = true; // Control de limpieza
    const fetchData = async () => {
      try {
        // Paso 1: Cargar y mostrar `ActData`
        const ActData = await fetchActs();
        const filtered = ActData?.filter(
          (a) => a?.code !== queryParams?.idActividad
        );

        const result = [];
        const count = Math.min(10, filtered?.length);

        // Copia temporal para no modificar el array original
        const temp = [...filtered];

        for (let i = 0; i < count; i++) {
          const randomIndex = Math.floor(Math.random() * temp?.length);
          result.push(temp[randomIndex]);
          temp.splice(randomIndex, 1); // Eliminar para no repetir
        }

        setRandomActivities(result);
      } catch (error) {
        console.error("Error fetching data:", error);
        if (isMounted) console.log("Failed to load data. Please try again.");
      }
    };

    fetchData();

    return () => {
      isMounted = false; // Limpiar al desmontar
    };
  }, [location?.search]);

  const fetchActs = async () => {
    const objDestino = requestData[1];
    try {
      const response = await getActividades(objDestino);

      return response?.activities;
    } catch (error) {
      console.error("Error fetching hotels:", error);
      return [];
    }
  };

  function updateCancellationPolicy(selectedValue) {
    const policy = modality?.rates?.[0]?.rateDetails
      .flatMap((rateDetail) => rateDetail?.operationDates)
      .find((operationDate) => operationDate?.from === selectedValue);

    setCancellationPolicies(policy);
  }

  function changeModalityRate(event) {
    const selectedValue = event?.target?.value;
    setDateSelected(selectedValue);
    updateCancellationPolicy(selectedValue?.split(", ")[0]);
  }

  const edadesFunc = () => {
    const edades = Object?.keys(queryParams)
      ?.filter((key) => key?.startsWith("pax")) // Filtramos las claves que empiezan con 'pax'
      ?.map((key) => {
        const [numAdultos, __, ___, edades] = queryParams[key].split("|");
        const adultos = edades
          ?.split(",")
          ?.filter(
            (edad) =>
              edad >=
              modality?.amountsFrom?.find(
                (typePax) => typePax?.paxType === "ADULT"
              )?.ageFrom
          );
        const menores = edades
          ?.split(",")
          ?.filter(
            (edad) =>
              edad >=
                modality?.amountsFrom?.find(
                  (typePax) =>
                    typePax?.paxType === "CHILD" &&
                    typePax?.ageFrom > 0 &&
                    typePax?.amount > 0
                )?.ageFrom &&
              edad <=
                modality?.amountsFrom?.find(
                  (typePax) =>
                    typePax?.paxType === "CHILD" &&
                    typePax?.ageFrom > 0 &&
                    typePax?.amount > 0
                )?.ageTo
          );
        const infantes = edades
          ?.split(",")
          ?.filter(
            (edad) =>
              edad <=
                modality?.amountsFrom?.find(
                  (typePax) =>
                    typePax?.paxType === "CHILD" && typePax?.ageFrom === 0
                )?.ageTo &&
              edad >=
                modality?.amountsFrom?.find(
                  (typePax) =>
                    typePax?.paxType === "CHILD" && typePax?.ageFrom === 0
                )?.ageFrom
          );

        return {
          numAdultos: parseInt(numAdultos) + adultos?.length, // Convertimos comas en pipes
          edad_menores: menores, // Convertimos comas en pipes
          edad_infantes: infantes, // Convertimos comas en pipes
          edades: edades?.split(","),
        };
      });

    return edades;
  };
  useEffect(() => {
    const edad = edadesFunc(); // Esto solo se ejecuta cuando `location.search` cambia
    setTotalEdades(edad);
  }, [location?.search, modality]);
  const saveURL = (urlPath, urlSearch) => {
    // Crear un array de habitaciones a agregar
    const newUrl = {
      pathName: urlPath,
      search: urlSearch,
    };
    // Agregar nuevas habitaciones correctamente
    const urlNew = [newUrl];

    // Guardar en sessionStorage
    const setDatos = {
      url: urlNew,
    };

    sessionStorage.setItem("urlSession", JSON.stringify(setDatos));
  };
  const precioMenores = modality?.amountsFrom?.find(
    (pax) => pax?.paxType === "CHILD" && pax?.ageFrom > 0
  )?.amount;
  const precioInfantes = modality?.amountsFrom?.find(
    (pax) => pax?.paxType === "CHILD" && pax?.ageFrom === 0
  )?.amount;
  cancellationPolicies?.cancellationPolicies?.forEach((policy) => {
    politicasText += `<strong>Fecha de cancelación:</strong> ${FormatCancellationPoliciesAct(
      policy?.dateFrom
    )} <br/>
      <strong>Monto de penalidad:</strong> ${Currency(
        policy?.amount
      )} <br/><br/>`;
  });
  const actualizarDatosAct = (
    dataNameAct,
    dataDestinoAct,
    dataCodePais,
    dataImg,
    totalPricesAct,
    totalApi
  ) => {
    sessionStorage.removeItem("datosReservaPP");
    const ahora = new Date();
    let fechaExpiracion;
    const datosPrevios = JSON.parse(sessionStorage.getItem("datosReserva")) || {
      hospedaje: [],
      actividades: [],
      traslados: [],
    };
    if (lang?.[0]?.languages?.length > 0 && !selectedLang) {
      rateKey = selectedLang?.split(", ")[1];
    } else {
      rateKey = dateSelected?.split(", ")[1];
    }
    if (datosPrevios?.actividades?.length === 0) {
      // Primera habitación: 30 minutos desde ahora
      fechaExpiracion = new Date(ahora.getTime() + 5 * 60 * 1000);
    } else {
      // Usar la fecha de expiración existente de la primera habitación
      fechaExpiracion = new Date(
        datosPrevios?.actividades?.[0]?.fechaExpiracion
      );
    }

    // Crear un array de habitaciones a agregar
    const nuevasActividades = {
      rateKey: rateKey,
      nombreActividad: dataNameAct,
      codigoActividad: acts?.activity?.code,
      // parametrosActividad: "",
      destino: dataDestinoAct,
      codigo_pais: dataCodePais,
      nombreModalidad: modality?.name,
      durationValue: modality?.duration?.value,
      durationMetric: modality?.duration?.metric,
      codedestino: acts?.activity?.country?.destinations?.[0]?.code,
      observaciones: modality?.comments?.[0]?.text,
      promoCode: modality?.promotions?.[0]?.code
        ? modality?.promotions?.[0]?.code
        : "",
      promoDateFrom: modality?.promotions?.[0]?.dateFrom
        ? modality?.promotions?.[0]?.dateFrom
        : "",
      promoDateTo: modality?.promotions?.[0]?.dateTo
        ? modality?.promotions?.[0]?.dateTo
        : "",
      imagenExp: dataImg,
      questionsAux: modality?.questions ? modality?.questions : [],
      totalAdultos: totalPersons?.[0]?.num_adultos,
      precioAdultoTotal: modality?.amountsFrom?.find(
        (pax) => pax?.paxType === "ADULT"
      )?.amount,
      totalMenores: totalPersons?.[0]?.num_menores,
      edadesMenoresArray: totalEdades?.[0]?.edades
        ? totalEdades?.[0]?.edades
        : [0],
      precioMenorTotal: precioMenores + precioInfantes,
      cancellationText: politicasText,
      selectedDate: dateSelected?.split(", ")[0],
      selectedLanguageAndSession:
        selectedLang?.length > 0 ? selectedLang?.split(", ")[0] : "",
      totalAmount: totalPricesAct,
      totalAmountApi: totalApi,
      fechaAgregado: ahora?.toISOString(),
      fechaExpiracion: fechaExpiracion?.toISOString(), // Misma para todas
      addedTime: acts?.auditData?.time,
      idUnico: acts?.activity?.activityCode,
      checkin: selectedDates?.[0],
      checkout: selectedDates?.[1],
      paxes: persons,
    };

    if (datosPrevios?.actividades?.length == 1) {
      Swal.fire({
        title: "Máximo de Actividades",
        text: "Solo se puede agregar una actividad por reservación.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Continuar con la reservación",
        cancelButtonText: "Cancelar esta actividad",
        denyButtonText: "Reemplazar Actividad",
        customClass: {
          confirmButton: "btn-purple w-auto",
          denyButton: "btn-purple w-auto",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // Continuar con la reservación
          navigate("/preventa");
        } else if (result.isDenied) {
          // Crear una copia del array actual
          let nuevaActividad = [...datosPrevios.actividades];

          // Reemplazar la última habitación con la nueva
          nuevaActividad[nuevaActividad?.length - 1] = Array.isArray(
            nuevasActividades
          )
            ? nuevasActividades[0] // Extrae el primer objeto si es un array
            : nuevasActividades;

          // Guardar en sessionStorage
          const setDatos = {
            idPasarela: pdp?.nombre,
            hospedaje: datosPrevios?.hospedaje,
            actividades: nuevaActividad,
            lastUpdate: ahora?.toISOString(),
            traslados: datosPrevios?.traslados,
          };

          sessionStorage.setItem("datosReserva", JSON.stringify(setDatos));
          window.dispatchEvent(new CustomEvent("cartUpdated"));
          window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
          // Actualizar el estado global en React
          setShowAlert(true);
          setArrSession(setDatos);
        }
      });
      return;
    } else if (
      lang?.[0]?.languages?.length > 0 &&
      !selectedLang &&
      dateSelected
    ) {
      Swal.fire({
        text: "Por favor seleccione un idioma para poder agregar su actividad.",
        showDenyButton: false,
        showConfirmButton: false,
        showCancelButton: false,
        timer: 2000,
      });
      return;
    } else if (
      lang?.[0]?.languages?.length > 0 &&
      !dateSelected &&
      !selectedLang
    ) {
      Swal.fire({
        text: "Por favor seleccione una fecha e idioma para poder agregar su actividad.",
        showDenyButton: false,
        showCancelButton: false,
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    } else if (
      lang?.[0]?.languages?.length > 0 &&
      selectedLang &&
      !dateSelected
    ) {
      Swal.fire({
        text: "Por favor seleccione una fecha para poder agregar su actividad.",
        showDenyButton: false,
        showConfirmButton: false,
        showCancelButton: false,
        timer: 2000,
      });
      return;
    } else if (lang?.[0]?.languages?.length === 0 && !dateSelected) {
      Swal.fire({
        text: "Por favor seleccione una fecha para poder agregar su actividad.",
        showDenyButton: false,
        showConfirmButton: false,
        showCancelButton: false,
        timer: 2000,
      });
      return;
    } else {
      // Agregar nuevas habitaciones correctamente
      const nuevaActividades = [...datosPrevios.actividades, nuevasActividades];

      // Guardar en sessionStorage
      const setDatos = {
        idPasarela: pdp?.nombre,
        hospedaje: datosPrevios?.hospedaje,
        actividades: nuevaActividades,
        lastUpdate: ahora?.toISOString(),
        traslados: datosPrevios?.traslados,
      };

      sessionStorage.setItem("datosReserva", JSON.stringify(setDatos));
      window.dispatchEvent(new CustomEvent("cartUpdated"));
      window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
      // Actualizar el estado global en React
      setShowAlert(true);
      setArrSession(setDatos);
    }
  };

  const onChangeLang = (e) => {
    setSelectedLang(e?.target?.value);
  };

  const tabs = [
    {
      key: "description",
      label: "Descripción",
      content: (
        <span
          style={{
            whiteSpace: "pre-line",
            fontSize: "20px",
            lineHeight: "2",
            color: "#4f5052",
            height: "20rem",
            maxHeight: "20rem",
            overflowY: "auto",
            display: "block",
          }}
          dangerouslySetInnerHTML={{
            __html: acts?.activity?.content?.description.replaceAll(
              "<br>",
              " "
            ),
          }}
        />
      ),
    },
    {
      key: "importantInformation",
      label: "Información Importante",
      content: (
        <>
          {acts?.activity?.content?.importantInfo?.map((amenity, index) => (
            <p
              style={{
                color: "#4f5052",
                fontSize: "20px",
                textAlign: "justify",
              }}
              key={index + 1}
            >
              {amenity}
              <br />
            </p>
          ))}
          {acts?.activity?.content?.location.startingPoints?.[0]?.meetingPoint
            ?.geolocation?.latitude !== "" && (
            <>
              <h4 className="mt-5 mb-4">
                <strong>Punto de Encuentro:</strong>
              </h4>
              <Link
                to={`https://www.google.com/maps/search/?api=1&query=${acts?.activity?.content?.location?.startingPoints?.[0]?.meetingPoint?.geolocation?.latitude},${acts?.activity?.content?.location?.startingPoints?.[0]?.meetingPoint?.geolocation?.longitude}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button className={"btnReservar"} style={{ fontSize: "20px" }}>
                  Ver ubicación <FaLocationDot />
                </Button>
              </Link>
            </>
          )}
        </>
      ),
    },
    {
      key: "cancellationPolicy",
      label: "Políticas de cancelación",
      content: (
        <>
          <p style={{ color: "#", fontSize: "25px" }}>
            Políticas de cancelación:
          </p>
          <p
            style={{
              color: "#4f5052",
              fontSize: "20px",
              textAlign: "justify",
            }}
          >
            Monto a pagar pasada la fecha límite de cancelación:{" "}
            <strong>
              {Currency(
                acts?.activity?.modalities?.[0]?.rates?.[0]?.rateDetails?.[0]
                  ?.operationDates?.[0]?.cancellationPolicies?.[0]?.amount
              )}{" "}
              MXN
            </strong>
          </p>
          <p
            style={{
              color: "#4f5052",
              fontSize: "20px",
              textAlign: "justify",
            }}
          >
            La fecha limite de cancelación dependerá de la fecha que seleccione
            para reservar su experiencia. <br />
            Fecha y hora calculados en base a la hora local en destino.
          </p>
        </>
      ),
    },
    {
      key: "observations",
      label: "Observaciones",
      content: (
        <span
          style={{
            whiteSpace: "pre-line",
            fontSize: "20px",
            lineHeight: "2",
            color: "#4f5052",
            height: "20rem",
            maxHeight: "20rem",
            overflowY: "auto",
            display: "block",
          }}
        >
          {acts?.activity?.modalities?.[0]?.comments?.[0] ? (
            <>
              {acts?.activity?.modalities?.[0]?.comments?.[0]?.text?.replaceAll(
                " // ",
                "\n"
              )}
            </>
          ) : (
            <span>No hay observaciones para esta actividad</span>
          )}
        </span>
      ),
    },
  ];

  const [destinies] = useState([
    {
      hotel: "Seadust Cancún Family Resort",
      location: "Cancún, México.",
      price: "$3,937",
      days: "10",
      img: moonPalace,
      stars: "5.0",
    },
    {
      hotel: "Hilton Cancun Mar Caribe All-Inclusive Resort",
      location: "Cancún, México",
      price: "$4,466",
      days: "10",
      img: hiltonCancun,
      stars: "4.5",
    },
    {
      hotel: "Moon Palace Cancún",
      location: "Cancún, México",
      price: "$8,061",
      days: "10",
      img: fiestaAmericana,
      stars: "4.3",
    },
  ]);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div className="info-experiencia">
      {loading && <Loader />}
      <div className="results container ">
        <div className="border-bottom border-2 mb-4">
          <div className="d-grid d-lg-flex justify-content-between mx-2 mt-4">
            <h3 className="text-rose">{acts?.activity?.name}</h3>
          </div>
          <p className="text-purple mx-2">
            {acts?.activity?.content?.countries?.[0]?.destinations?.[0]?.name},{" "}
            {acts?.activity?.content?.countries?.[0]?.name}
          </p>
        </div>
        <Row>
          <Col lg={9} md={7} xs={12}>
            <Row className="mb-4">
              <GalleryInfo
                images={acts?.activity?.content?.media?.images}
                isHotel={false}
              />
            </Row>
          </Col>
          <Col lg={3} md={5} sm={12}>
            {/* <div className="d-md-flex d-none h-100">
              <Container
                className="d-flex justify-content-center align-items-center"
                style={{ position: "relative" }}
              >
                <div style={{ position: "relative" }}>
                  <img
                    src={bannerAyuda}
                    alt="Imagen con botones"
                    style={{
                      width: "100%",
                      height: "610px",
                      display: "block",
                      borderRadius: "50px",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "45%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                    }}
                  >
                    <Row>
                      <Col className="pb-4">
                        <Button
                          className="btn-blue"
                          style={{ width: "100%", borderRadius: "3rem" }}
                          href="tel:9982189740"
                          variant="primary"
                        >
                          <BsFillTelephoneFill /> Llama ahora{" "}
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Button
                          className="btn-blue"
                          style={{ width: "220px", borderRadius: "3rem" }}
                          variant="secondary"
                          onClick={handleShow}
                        >
                          <FaPhoneVolume /> Agenda una llamada
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Container>
            </div> */}
            <SearchEngine
              isInfoService={true}
              alojamientos={false}
              actividades={true}
              isModify={true}
              hideDestination={true}
              hideSearchDestination={hideSearchDestination}
              setHideSearchDestination={setHideSearchDestination}
              isHotel={false}
              actId={queryParams?.idActividad}
              isExperiencias={true}
              isInfoHotel={true}
              isTraslados={false}
              totalRooms={[]}
              modifyAct={"actividad"}
              totalPersons={totalPersons}
              arrayPersons={persons}
              destination={nameDestination}
              idLocation={queryParams?.idDestino}
              selectedDates={selectedDates}
            />
          </Col>
        </Row>
      </div>
      <Modal show={show} centered onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Contáctanos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <GeneralForm
            urlSection={location.pathname + location.search}
            isContactForm={true}
            isRentalCarForm={false}
          />
        </Modal.Body>
      </Modal>
      <div className="container d-flex justify-content-center mb-5">
        <Row>
          <Col lg={12}>
            <h5 className="fs-3 p-3 text-lg-start text-center">
              Elije tu modalidad
            </h5>
          </Col>
          <Col lg={12} style={{}} className="shadow rounded-4">
            <Row>
              <Col
                lg={12}
                md={12}
                className="p-3 pb-0"
                style={{
                  borderBottom: "2px solid #00a9b7",
                  borderRadius: "5px 5px 0px 0px #00a8b760",
                }}
              >
                <Row>
                  {acts?.activity?.modalities?.map((modalities) => (
                    <Col lg={3} md={3} key={modalities?.uniqueIdentifier}>
                      <Button
                        onClick={() => changeModality(modalities)}
                        className={
                          modality?.uniqueIdentifier ===
                          modalities?.uniqueIdentifier
                            ? "btnModalitySelected"
                            : "btnModality"
                        }
                        // style={{ marginBottom: "15px" }}
                      >
                        {modalities?.name}
                      </Button>
                    </Col>
                  ))}
                </Row>
              </Col>
              {modality?.rates?.[0]?.rateDetails?.[0]?.operationDates?.find(
                (operationDate) =>
                  operationDate?.cancellationPolicies?.length > 0
              ) ? (
                <>
                  <Col
                    lg={12}
                    // className="shadow rounded-4"
                    // style={{ backgroundColor: "" }}
                  >
                    <Row className="p-4">
                      <Col lg={4} className="mb-3">
                        <h5
                          style={{
                            color: "#000",
                            fontWeight: "bold",
                            fontSize: "25px",
                          }}
                        >
                          {acts?.activity?.name}
                        </h5>

                        <p
                          style={{
                            color: "#000",
                            fontSize: "17px",
                            margin: "0",
                          }}
                        >
                          {acts?.activity?.country?.destinations[0]?.name}
                        </p>
                        <p style={{ color: "#000", fontSize: "17px" }}>
                          {modality?.name}
                        </p>
                        {modality?.promotions?.[0] && (
                          <p style={{ color: "#000", fontSize: "17px" }}>
                            Promoción: {modality?.promotions?.[0]?.code} -{" "}
                            {modality?.promotions?.[0]?.description}
                            <br />{" "}
                            <small>
                              Válido desde:{" "}
                              {FormatDate(modality?.promotions?.[0]?.dateFrom)}{" "}
                              al {FormatDate(modality?.promotions?.[0]?.dateTo)}
                            </small>
                          </p>
                        )}
                        {/* <p style={{ color: "#000", fontSize: "17px", margin: "0" }}>
                      Nuestras formas de pago:
                      <img src="" alt="" />
                    </p> */}
                      </Col>
                      <Col lg={4} className="mb-3">
                        <p
                          style={{
                            color: "#000",
                            fontSize: "25px",
                            margin: "0",
                          }}
                        >
                          Cantidad de personas:
                        </p>
                        <p
                          style={{
                            color: "#000",
                            fontSize: "17px",
                            margin: "0",
                          }}
                        >
                          {modality?.amountsFrom?.find(
                            (pax) => pax?.paxType === "ADULT"
                          ) && (
                            <span>
                              {totalEdades?.[0]?.numAdultos} Adulto(s) - (
                              {
                                modality?.amountsFrom?.find(
                                  (pax) => pax?.paxType === "ADULT"
                                )?.ageFrom
                              }{" "}
                              -{" "}
                              {modality?.amountsFrom
                                ?.find((pax) => pax?.paxType === "ADULT")
                                ?.ageTo?.toString()
                                ?.slice(0, 2)}{" "}
                              años) -{" "}
                              {Currency(
                                totalPrices(
                                  modality?.amountsFrom?.find(
                                    (pax) => pax?.paxType === "ADULT"
                                  )?.amount,
                                  markup,
                                  nights
                                )[1]
                              )}
                              <span style={{ fontSize: "12px" }}> MXN</span>
                            </span>
                          )}
                        </p>
                        <p
                          style={{
                            color: "#000",
                            fontSize: "17px",
                            margin: "0",
                          }}
                        >
                          {totalPersons?.[0]?.num_menores > 0 &&
                            totalEdades?.[0]?.edad_menores?.length > 0 && (
                              <span>
                                {totalEdades?.[0]?.edad_menores?.length}{" "}
                                Menor(es) - (
                                {
                                  modality?.amountsFrom?.find(
                                    (pax) =>
                                      pax?.paxType === "CHILD" &&
                                      pax?.ageFrom > 0
                                  )?.ageFrom
                                }{" "}
                                -{" "}
                                {
                                  modality?.amountsFrom?.find(
                                    (pax) =>
                                      pax?.paxType === "CHILD" &&
                                      pax?.ageFrom > 0
                                  )?.ageTo
                                }{" "}
                                años) -{" "}
                                {Currency(
                                  totalPrices(
                                    modality?.amountsFrom?.find(
                                      (pax) =>
                                        pax?.paxType === "CHILD" &&
                                        pax?.ageFrom > 0
                                    )?.amount,
                                    markup,
                                    nights
                                  )[1]
                                )}{" "}
                                <span style={{ fontSize: "12px" }}>MXN</span>
                              </span>
                            )}
                        </p>
                        <p
                          style={{
                            color: "#000",
                            fontSize: "17px",
                            margin: "0",
                          }}
                        >
                          {totalPersons?.[0]?.num_menores > 0 &&
                            totalEdades?.[0]?.edad_infantes?.length > 0 && (
                              <span>
                                {totalEdades?.[0]?.edad_infantes?.length}{" "}
                                Infante(s) - (
                                {
                                  modality?.amountsFrom?.find(
                                    (pax) =>
                                      pax?.paxType === "CHILD" &&
                                      pax?.ageFrom === 0
                                  )?.ageFrom
                                }{" "}
                                -{" "}
                                {
                                  modality?.amountsFrom?.find(
                                    (pax) =>
                                      pax?.paxType === "CHILD" &&
                                      pax?.ageFrom === 0
                                  )?.ageTo
                                }{" "}
                                años) -{" "}
                                {Currency(
                                  totalPrices(
                                    modality?.amountsFrom?.find(
                                      (pax) =>
                                        pax?.paxType === "CHILD" &&
                                        pax?.ageFrom === 0
                                    )?.amount,
                                    markup,
                                    nights
                                  )[1]
                                )}{" "}
                                <span style={{ fontSize: "12px" }}>MXN</span>
                                <br />
                              </span>
                            )}
                        </p>
                        {modality?.rates?.[0]?.rateDetails?.[0]?.operationDates?.find(
                          (operationDate) =>
                            operationDate?.cancellationPolicies?.length > 0
                        ) && (
                          <>
                            <p
                              style={{
                                color: "#000",
                                fontSize: "25px",
                                margin: "0",
                              }}
                            >
                              Políticas de cancelación:
                            </p>
                            <p
                              style={{
                                color: "#000",
                                fontSize: "17px",
                                margin: "0",
                              }}
                            >
                              Fecha límite de cancelación:{" "}
                              {FormatCancellationPoliciesAct(
                                cancellationPolicies?.cancellationPolicies?.[0]
                                  ?.dateFrom
                              )}
                            </p>
                            <p
                              style={{
                                color: "#000",
                                fontSize: "17px",
                                margin: "0",
                              }}
                            >
                              Monto a pagar:{" "}
                              {Currency(
                                cancellationPolicies?.cancellationPolicies?.[0]
                                  ?.amount
                              )}
                            </p>
                            <p
                              style={{
                                color: "#000",
                                fontSize: "17px",
                                margin: "0",
                              }}
                            >
                              Fecha y hora calculados en base a la hora local
                              del destino.
                            </p>
                          </>
                        )}
                        <Form>
                          <Form.Group>
                            <Form.Label
                              style={{
                                color: "#000",
                                fontSize: "25px",
                                margin: "0",
                              }}
                            >
                              Seleccione el día:
                            </Form.Label>
                            <Form.Select
                              id="dateActivity"
                              onChange={changeModalityRate}
                              required
                            >
                              <option value="">
                                Selecciona la fecha de tu actividad
                              </option>
                              {modality?.rates?.map((operation) =>
                                operation?.rateDetails?.[0]?.operationDates?.map(
                                  (operate) => (
                                    <option
                                      key={operate?.from}
                                      value={
                                        operate?.from +
                                        ", " +
                                        operation?.rateDetails?.[0]?.rateKey
                                      }
                                    >
                                      {FormatDate(operate?.from)}
                                    </option>
                                  )
                                )
                              )}
                            </Form.Select>
                          </Form.Group>
                        </Form>
                        {lang?.[0]?.languages?.length > 0 && (
                          <Form>
                            <Form.Group>
                              <Form.Label
                                style={{
                                  color: "#000",
                                  fontSize: "25px",
                                  margin: "0",
                                }}
                              >
                                Seleccione el idioma y/o horario:
                              </Form.Label>
                              <Form.Select
                                id="langAndTime"
                                onChange={(e) => onChangeLang(e)}
                                required
                              >
                                <option value="">
                                  Selecciona el idioma u horario de tu actividad
                                </option>
                                {lang?.map((language) =>
                                  language?.languages?.map((lan) => (
                                    <option
                                      value={
                                        lan?.code +
                                        "|" +
                                        language?.sessions?.[0]?.code +
                                        ", " +
                                        language?.rateKey
                                      }
                                    >
                                      {lan?.description}{" "}
                                      {language?.sessions?.[0]?.name}
                                    </option>
                                  ))
                                )}
                              </Form.Select>
                            </Form.Group>
                          </Form>
                        )}
                      </Col>
                      <Col
                        lg={4}
                        className="text-start text-lg-end text-sm-end"
                      >
                        <p
                          style={{
                            color: "#000",
                            fontSize: "17px",
                            margin: "0",
                          }}
                        >
                          {totalPersons?.[0]?.num_adultos} Adulto(s),{" "}
                          {totalPersons?.[0]?.num_menores} Menor(es)
                        </p>
                        <p
                          style={{
                            color: "rgb(57 100 171)",
                            fontSize: "25px",
                            margin: "0",
                          }}
                        >
                          Precio Total:{" "}
                          {comisionUsuario?.actividades && (
                            <>
                              <br />
                              <span
                                style={{
                                  fontSize: "18px",
                                  color: "#8e8e8e",
                                  textDecoration: "line-through",
                                }}
                              >
                                {Currency(
                                  totalPrices(
                                    modality?.rates?.[0]?.rateDetails?.[0]
                                      ?.totalAmount?.amount,
                                    markup,
                                    nights
                                  )[1]
                                )}{" "}
                                MXN
                              </span>
                              <br />
                            </>
                          )}
                          {Currency(
                            totalPrices(
                              modality?.rates?.[0]?.rateDetails?.[0]
                                ?.totalAmount?.amount,
                              markup,
                              nights,
                              comisionUsuario?.actividades
                            )[1]
                          ) + " MXN"}
                        </p>
                        <p style={{ color: "#000", fontSize: "17px" }}>
                          Impuestos Incluidos*
                        </p>
                        <div className="d-grid justify-content-center justify-content-md-end gap-2">
                          <Button
                            onClick={() =>
                              actualizarDatosAct(
                                // modality,
                                acts?.activity?.name,
                                acts?.activity?.country?.destinations?.[0]
                                  ?.name,
                                acts?.activity?.country?.code,
                                acts?.activity?.content?.media?.images?.[0]
                                  ?.urls[1]?.resource,

                                totalPrices(
                                  modality?.rates?.[0]?.rateDetails?.[0]
                                    ?.totalAmount?.amount,
                                  markup,
                                  nights,
                                  comisionUsuario?.actividades
                                )[1],
                                modality?.rates?.[0]?.rateDetails?.[0]
                                  ?.totalAmount?.amount
                              )
                            }
                            className={"btnReservar"}
                          >
                            Añadir al carrito
                          </Button>
                          <Button
                            onClick={() =>
                              window.scrollTo({ top: 0, behavior: "smooth" })
                            }
                            className={"btnReservar"}
                          >
                            Modificar busqueda
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </>
              ) : (
                <>
                  <h2 className="text-center">
                    Esta Modalidad no esta disponible, por favor selecciona o
                    busca otra actividad de tu preferencia.
                  </h2>
                </>
              )}
            </Row>
          </Col>
        </Row>
      </div>

      <div className="container py-2 py-sm-2 py-lg-2">
        <Tab.Container
          activeKey={activeKey}
          onSelect={(key) => setActiveKey(key)}
        >
          <Row>
            {/* Columna izquierda (Tabs) */}
            <Col md={5} className="">
              <Nav className="flex-column">
                {tabs.map((tab) => (
                  <Nav.Item key={tab.key}>
                    <Nav.Link
                      eventKey={tab.key}
                      style={{
                        fontSize: activeKey === tab.key ? "28px" : "24px",
                        fontWeight: activeKey === tab.key ? "bold" : "normal",
                        color: "black",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        borderBottom: "2px solid", // Borde inferior
                        borderBottomColor:
                          activeKey === tab.key ? "#3864ab" : "lightgray", // Color dinámico
                      }}
                      className="py-2"
                    >
                      {/* Flecha dinámica */}
                      <span
                        style={{
                          marginRight: "10px",
                          transition: "transform 0.4s ease",
                        }}
                      >
                        {activeKey === tab.key ? (
                          <IoIosArrowUp />
                        ) : (
                          <IoIosArrowDown />
                        )}
                      </span>
                      {tab.label}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>

            {/* Columna derecha (Contenido) */}
            <Col md={7} className="p-4" style={{ textAlign: "justify" }}>
              <Tab.Content>
                {tabs.map((tab) => (
                  <Tab.Pane key={tab.key} eventKey={tab.key}>
                    <p>{tab.content}</p>
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>

      <div className="section-about-reservation py-0 py-sm-5 py-lg-5">
        <div className="section-cards-hotel container mb-5">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="text-lg-start text-center fw-bold title-home pb-3 mb-4 border-1 border-black border-bottom hotel-ideal">
              ¿No logras encontrar tu experiencia?
            </h3>
            <h5
              className="title-home d-lg-flex d-none text-start"
              style={{ fontSize: "30px", width: "30rem" }}
            >
              Mira estas experiencias para tu viaje ideal.
            </h5>
          </div>
          <Row className="cards-sliders d-flex justify-content-center">
            <Slider {...settingsInfoHotel} className="hotels-slider">
              {randomActivities.map((dataActs, index) => {
                return (
                  <div
                    className="d-flex justify-content-center"
                    key={index + 1}
                  >
                    <CardCarrousel
                      seccion={"experenciasInfo"}
                      dataInfo={dataActs}
                      markup={markup}
                      nights={nights}
                      selectedDates={selectedDates}
                    />
                  </div>
                );
              })}
            </Slider>
          </Row>
        </div>
      </div>
      <CheckOutCart
        arrDatos={arrSession}
        urlSession={() => saveURL(location?.pathname, location?.search)}
        setAlert={setShowAlert}
        showAlert={showAlert}
        setAlertMessage={"Se agrego una nueva actividad"}
      />
    </div>
  );
};
